import { render, staticRenderFns } from "./TheWatermark.vue?vue&type=template&id=bd3595d6&scoped=true"
import script from "./TheWatermark.vue?vue&type=script&lang=js"
export * from "./TheWatermark.vue?vue&type=script&lang=js"
import style0 from "./TheWatermark.vue?vue&type=style&index=0&id=bd3595d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3595d6",
  null
  
)

export default component.exports